import { Button } from "antd";

// 错误回退组件
const ErrorBoundaryPage = ({ error, resetErrorBoundary }: any) => {
    // 检查错误类型
    if (error.message.includes("Failed to fetch")) {
        // 如果是资源加载失败，提示用户刷新页面
        return (
            <div>
                <h2>版本有更新请刷新使用新版本。{error.message}</h2>
                <Button onClick={() => window.location.reload()}>刷新页面</Button>
            </div>
        );
    }

    // 默认的错误处理
    return (
        <div>
            <h2>发生了一个错误: {error.message}</h2>
            <button onClick={resetErrorBoundary}>重试</button>
        </div>
    );
};

export default ErrorBoundaryPage;